<template>
  <div class="table-filter">
    <div class="table-filter-label">SEARCH</div>
    <div class="input-group">
      <input v-model="value" type="text" ref="filter" class="form-control table-filter-input" placeholder="Enter text to filter">
      <span @click.prevent="reset()" :class="{ 'input-group-addon': true, 'primary': value.length > 0 }"><i class="pg-close_line"></i></span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TableFilter',
    props: {
      search: {
        type: Function,
        default: (query) => {}
      }
    },
    data: () => ({
      value: ''
    }),
    methods: {
      reset() {
        this.value = '';
        this.search(this.value);
      }
    },
    created() {
      this.$watch('value', (value) => {
        this.search(value);
      });
    }
  }
</script>

<style>
  .table-filter {
    margin: 30px 0;
  }
  .table-filter-label {
    font-family: 'Montserrat';
    text-transform: uppercase;
    letter-spacing: 0.02em;
    font-size: 12px;
    font-weight: 600;
  }

  .table-filter-input {    
    background: white;
    border: none;
    border-bottom: 1px solid #e8e8e8;
    text-align: left;
    text-transform: lowercase;
    letter-spacing: 0.02em;
    font-size: 12px;
    font-weight: 400;
  }

  .table-filter .input-group {
    margin-top: 8px;
  }

  .table-filter .input-group-addon {
    cursor: pointer;
  }
  .no-padding {
    padding: 0;
  }
</style>


// WEBPACK FOOTER //
// table_filter.vue?4fd32b4c